import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCDoWMfGTjPRQJHCJWWt9JdjXBLu214ygM",
  authDomain: "anti-theft-3ed12.firebaseapp.com",
  projectId: "anti-theft-3ed12",
  storageBucket: "anti-theft-3ed12.appspot.com",
  messagingSenderId: "1033914436706",
  appId: "1:1033914436706:web:bf606932831a8a5e75553b",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);
